module.exports = __webpack_public_path__ + "static/media/ic-speech-bubble.8f5bbb7f.svg";